// extracted by mini-css-extract-plugin
export default {"skin":"SkinDisplay_skin__st0sx"};